import React, { useState } from "react";
import Header from "../../common/Header/header";
import user_icn from "../../../assets/images/societies-icn.svg";
import {
  Table,
  Select,
  Modal,
  Button,
  Popconfirm,
  Descriptions,
  Tag,
  Empty,
} from "antd";
import { DeleteOutlined } from "@ant-design/icons";
import "./manageUser.scss";
import preve_arrow from "../../../images/prve-arrow.png";
import { useNavigate } from "react-router-dom";
import search_icn from "../../../assets/images/search-1.svg";
import cross_icn from "../../../assets/images/cross.svg";

const ManageUsersComponent = (props) => {
  const {
    user_table_columns,
    userDataList,
    handleRoleChange,
    handleStatusChange,
    handleWingFilterChange,
    handleClearFilters,
    filters,
    selectedRoles,
    selectedWing,
    wingList,
    confirmRoleModal,
    setConfirmRoleModal,
    confirmDeleteModal,
    setConfirmDeleteModal,
    selectedUser,
    setSelectedRoles,
    handleConfirmRole,
    handleConfirmDelete,
    filteredData,
    searchText,
    setSearchText,
    infoModalVisible,
    setInfoModalVisible,
    selectedUserForInfo,
    handleDeleteRole,
  } = props;

  const navigate = useNavigate();
  const [wingFilter, setWingFilter] = useState("");

  const applyWingFilter = (data, wing) => {
    if (!wing) return data;
    return data.filter((user) => user.wings === wing);
  };

  const filteredDataWithWing = applyWingFilter(filteredData, wingFilter);

  const isAnyFilterActive =
    searchText ||
    filters.role ||
    filters.status ||
    filters.startDate ||
    filters.endDate ||
    selectedWing;

  const roleOptions = [];
  if (selectedUser?.role) {
    if (selectedUser.role.includes("sub_owner")) {
      roleOptions.push({ label: "Sub Owner", value: "sub_owner" });
      roleOptions.push({ label: "Wing President", value: "wing_president" });
    } else if (selectedUser.role.includes("owner")) {
      roleOptions.push({ label: "Owner", value: "owner" });
      roleOptions.push({ label: "Wing President", value: "wing_president" });
    }
  }

  return (
    <>
      <Header title="User Details" />
      <div className="header-title" onClick={() => navigate("/society-list")}>
        <img src={preve_arrow} alt="preve_arrow" className="preve_arrow" />
        <span> Society List</span>
      </div>
      <div className="user-main">
        <div className="user-first">
          <div className="left-section">
            <h1>Manage Users</h1>
            <p className="dec-text">
              This section provides information about each society's users,
              including their names, roles, phone numbers, wings, and flat
              numbers.
            </p>
          </div>
          <div className="right-section">
            <div className="card-1 card">
              <img src={user_icn} alt="" />
              <div className="details">
                <h1>{userDataList?.length || 0}</h1>
                <p>Total User</p>
              </div>
            </div>
          </div>
        </div>
        <div className="user-second">
          <div className="left-section">
            <div className="search-box">
              <img src={search_icn} alt="Search" className="search-icon" />
              <input
                type="text"
                placeholder="Search by Name"
                value={searchText}
                onChange={(e) => setSearchText(e.target.value)}
                style={{
                  flex: 1,
                  border: "none",
                  outline: "none",
                  fontSize: "16px",
                  color: "#333",
                  background: "transparent",
                }}
              />
              {searchText && (
                <button onClick={() => setSearchText("")}>
                  <img src={cross_icn} alt="clear" className="clear-icon" />
                </button>
              )}
            </div>
            <Select
              className="select-type"
              placeholder="User Role"
              onChange={handleRoleChange}
              optionFilterProp="children"
              defaultValue={"Role"}
              value={filters.role}
              allowClear
            >
              <Select.Option value="president">President</Select.Option>
              <Select.Option value="wing_president">
                Wing President
              </Select.Option>
              <Select.Option value="owner">Owner</Select.Option>
              <Select.Option value="sub_owner">Sub Owner</Select.Option>
              <Select.Option value="guard">Guard</Select.Option>
              <Select.Option value="wing_guard">Wing Guard</Select.Option>
            </Select>
            <Select
              className="select-wing"
              placeholder="Select Wing"
              onChange={handleWingFilterChange}
              value={selectedWing}
              allowClear
            >
              {wingList?.map((wing) => (
                <Select.Option key={wing.wingId} value={wing.wingId}>
                  {wing.wingName}
                </Select.Option>
              ))}
            </Select>
          </div>
          <div className="right-section">
            <button
              onClick={() => {
                handleClearFilters();
                setWingFilter("");
              }}
              disabled={!isAnyFilterActive}
            >
              Clear
            </button>
          </div>
        </div>
        <div className="user-list">
          <Table
            dataSource={filteredDataWithWing}
            columns={user_table_columns}
            pagination={{
              position: ["bottomCenter"],
              showSizeChanger: true,
              pageSizeOptions: ["10", "25", "50", "100"],
              defaultPageSize: 10,
            }}
            scroll={{ x: "max-content" }}
            className="society-table"
            tableLayout="fixed"
          />
        </div>
      </div>

      <Modal
        centered
        open={confirmRoleModal}
        cancelButtonProps={{ style: { display: "none" } }}
        okButtonProps={{ style: { display: "none" } }}
        onCancel={() => setConfirmRoleModal(false)}
        className="approve-popup"
      >
        <div style={{ textAlign: "center", padding: "20px" }}>
          <div
            style={{
              fontSize: "18px",
              fontWeight: "bold",
              marginBottom: "10px",
            }}
          >
            You Can Assign New Role To User From Here !!!
          </div>
          <div
            style={{
              backgroundColor: "#f8f9fa",
              padding: "15px",
              borderRadius: "8px",
              marginBottom: "15px",
              textAlign: "left",
            }}
          >
            {selectedUser && (
              <div>
                <p>
                  <strong>Name:</strong>{" "}
                  {selectedUser.name
                    ? selectedUser.name.charAt(0).toUpperCase() +
                      selectedUser.name.slice(1)
                    : "N/a"}
                </p>
                <p>
                  <strong>Phone Number:</strong>{" "}
                  {selectedUser.phone_number || "N/a"}
                </p>
                <p>
                  <strong>Wings:</strong>{" "}
                  {selectedUser.wings
                    ? selectedUser.wings.charAt(0).toUpperCase() +
                      selectedUser.wings.slice(1)
                    : "N/a"}
                </p>
                <p>
                  <strong>Flat Number:</strong> {selectedUser.flat_no || "N/a"}
                </p>
                <p>
                  <strong>Current Role:</strong>{" "}
                  {selectedUser.role && selectedUser.role !== 'N/a'
                    ? selectedUser.role
                        .split(",")
                        .map(
                          (r) =>
                            r.trim().replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())
                        )
                        .join(", ")
                    : "N/a"}
                </p>
              </div>
            )}
          </div>
          <div style={{ marginBottom: "15px", textAlign: "left" }}>
            <label
              style={{
                fontSize: "16px",
                fontWeight: "bold",
                display: "block",
                marginBottom: "5px",
              }}
            >
              Select New Role:
            </label>
            <div style={{ width: "100%" }}>
              {roleOptions.map((role) => (
                <label
                  key={role.value}
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    marginBottom: "5px",
                  }}
                >
                  <input
                    type="radio"
                    name="role"
                    value={role.value}
                    checked={selectedRoles === role.value}
                    onChange={(e) => setSelectedRoles(e.target.value)}
                  />
                  {role.label}
                </label>
              ))}
            </div>
          </div>
          <div>
            <Button
              type="primary"
              danger
              style={{
                marginRight: "10px",
                padding: "8px 16px",
                fontSize: "14px",
              }}
              onClick={() => setConfirmRoleModal(false)}
            >
              Cancel
            </Button>
            <Button
              type="primary"
              warning
              style={{
                padding: "8px 16px",
                fontSize: "14px",
              }}
              disabled={!selectedRoles}
              onClick={handleConfirmRole}
            >
              Confirm
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        centered
        open={confirmDeleteModal}
        onCancel={() => setConfirmDeleteModal(false)}
        footer={null}
        style={{ textAlign: "center", borderRadius: "10px", padding: "20px" }}
      >
        <div
          style={{
            padding: "20px",
            backgroundColor: "#fff",
            borderRadius: "10px",
            boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
          }}
        >
          <h2
            style={{
              fontSize: "22px",
              fontWeight: "700",
              color: "#ff4d4f",
              marginBottom: "10px",
            }}
          >
            Delete User
          </h2>

          {selectedUser &&
          selectedUser.roles &&
          selectedUser.roles.length > 1 ? (
            <div>
              <div
                style={{
                  padding: "10px",
                  backgroundColor: "#FFFBE6",
                  border: "1px solid #FFC107",
                  borderRadius: "8px",
                  marginBottom: "20px",
                  textAlign: "left",
                }}
              >
                <h3
                  style={{
                    color: "#D97706",
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: "bold",
                  }}
                >
                  Warning: Multiple Roles Detected!
                </h3>
                <p
                  style={{ color: "#444", marginTop: "5px", fontSize: "14px" }}
                >
                  This user has multiple assignments. Deleting the user will
                  remove them from all associated roles and flats.
                </p>
              </div>
              <div style={{ textAlign: "left", marginBottom: "20px" }}>
                <p style={{ margin: "5px 0", fontSize: "15px", color: "#333" }}>
                  <strong>Name:</strong> {selectedUser.name || "N/a"}
                </p>
                <p style={{ margin: "5px 0", fontSize: "15px", color: "#333" }}>
                  <strong>Phone:</strong> {selectedUser.phone_number || "N/a"}
                </p>
                <h4
                  style={{
                    marginTop: "15px",
                    borderBottom: "1px solid #eee",
                    paddingBottom: "5px",
                    fontSize: "15px",
                  }}
                >
                  User Assignments:
                </h4>
                <div
                  style={{
                    maxHeight: "150px",
                    overflowY: "auto",
                    paddingRight: "10px",
                  }}
                >
                  {selectedUser.roles.map((roles, index) => (
                    <div
                      key={index}
                      style={{
                        backgroundColor: "#F8F9FA",
                        padding: "10px",
                        borderRadius: "8px",
                        marginTop: "10px",
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                      }}
                    >
                      <p style={{ margin: 0, fontSize: "14px" }}>
                        <strong>Wing:</strong> {roles.wing || "N/a"},{" "}
                        <strong>Flat:</strong> {roles.flat || "N/a"}
                      </p>
                      <p style={{ margin: "5px 0 0 0", fontSize: "14px" }}>
                        <strong>Roles:</strong>{" "}
                        {roles.roles.join(", ") || "N/a"}
                      </p>
                      <Popconfirm
                        title="Delete Roles?"
                        description="Are you sure you want to remove all roles for this assignment?"
                        onConfirm={() => {

                          const payload = {
                            userId: selectedUser?.user_id,
                            flatId: roles?.flat_id,
                            wingId: roles?.wing_id,
                            roles: roles?.roles,
                          };
                          handleDeleteRole(payload);
                          setConfirmDeleteModal(false)
                        }}
                        okText="Yes"
                        cancelText="No"
                      >
                        <Button
                          icon={<DeleteOutlined />}
                          danger
                          type="primary"
                        />
                      </Popconfirm>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          ) : (
            <>
              <p
                style={{
                  fontSize: "16px",
                  color: "#666",
                  margin: "10px 0 10px",
                }}
              >
                Are you sure you want to remove this user?
              </p>
              <p
                style={{
                  fontSize: "16px",
                  color: "#ff4d4f",
                  margin: "10px 0 10px",
                }}
              >
                This action cannot be undone.
              </p>
              {selectedUser && (
                <div
                  style={{
                    backgroundColor: "#F8F9FA",
                    padding: "15px",
                    borderRadius: "8px",
                    textAlign: "left",
                    marginBottom: "20px",
                  }}
                >
                  <p
                    style={{ margin: "5px 0", fontSize: "15px", color: "#333" }}
                  >
                    <strong>Name:</strong> {selectedUser.name || "N/a"}
                  </p>
                  <p
                    style={{ margin: "5px 0", fontSize: "15px", color: "#333" }}
                  >
                    <strong>Phone Number:</strong>{" "}
                    {selectedUser.phone_number || "N/a"}
                  </p>
                  <p
                    style={{ margin: "5px 0", fontSize: "15px", color: "#333" }}
                  >
                    <strong>Wing:</strong>{" "}
                    {selectedUser.roles?.[0]?.wing || "N/a"}
                  </p>
                  <p
                    style={{ margin: "5px 0", fontSize: "15px", color: "#333" }}
                  >
                    <strong>Flat Number:</strong>{" "}
                    {selectedUser.roles?.[0]?.flat || "N/a"}
                  </p>
                  <p
                    style={{
                      margin: "5px 0",
                      fontSize: "15px",
                      color: "#ff4d4f",
                    }}
                  >
                    <strong>Current Role:</strong>{" "}
                    {selectedUser.roles?.[0]?.roles?.join(", ") || "N/a"}
                  </p>
                </div>
              )}
            </>
          )}

          <div
            style={{ display: "flex", justifyContent: "center", gap: "10px" }}
          >
            <Button
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "600",
                backgroundColor: "#ccc",
                color: "#333",
                border: "none",
                borderRadius: "5px",
              }}
              onClick={() => setConfirmDeleteModal(false)}
            >
              Cancel
            </Button>
            <Button
              style={{
                padding: "8px 16px",
                fontSize: "14px",
                fontWeight: "600",
                backgroundColor: "#ff4d4f",
                color: "#fff",
                border: "none",
                borderRadius: "5px",
              }}
              onClick={() => handleConfirmDelete(selectedUser.id)}
            >
              Confirm Delete
            </Button>
          </div>
        </div>
      </Modal>

      <Modal
        title="User Role Details"
        open={infoModalVisible}
        onCancel={() => setInfoModalVisible(false)}
        footer={[
          <Button
            key="close"
            type="primary"
            onClick={() => setInfoModalVisible(false)}
          >
            Close
          </Button>,
        ]}
        width={600}
      >
        {selectedUserForInfo ? (
          <div>
            <Descriptions
              bordered
              column={1}
              size="small"
              style={{ marginBottom: 24 }}
            >
              <Descriptions.Item label="Name">
                <span style={{ fontWeight: "bold" }}>
                  {selectedUserForInfo.name}
                </span>
              </Descriptions.Item>
              <Descriptions.Item label="Phone">
                {selectedUserForInfo.phone_number || "N/A"}
              </Descriptions.Item>
            </Descriptions>

            <h3
              style={{
                marginBottom: 16,
                borderBottom: "1px solid #f0f0f0",
                paddingBottom: 8,
              }}
            >
              Roles & Assignments
            </h3>

            {selectedUserForInfo.assignments &&
            selectedUserForInfo.assignments.length > 0 ? (
              selectedUserForInfo.assignments.map((assignment, index) => (
                <div
                  key={assignment.flat_id || index}
                  style={{
                    background: "#fafafa",
                    border: "1px solid #e8e8e8",
                    borderRadius: 8,
                    padding: 16,
                    marginBottom: 16,
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                  }}
                >
                  <div>
                    <p
                      style={{
                        margin: 0,
                        fontWeight: "bold",
                        fontSize: "16px",
                        color: "#333",
                      }}
                    >
                      Wing: {assignment.wing || "N/A"} - Flat:{" "}
                      {assignment.flat || "N/A"}
                    </p>
                    <div style={{ marginTop: 10 }}>
                      <strong style={{ marginRight: 8 }}>Roles:</strong>
                      {assignment.roles && assignment.roles.length > 0 ? (
                        assignment.roles.map((role, roleIndex) => (
                          <Tag
                            color="blue"
                            key={roleIndex}
                            style={{ margin: "2px" }}
                          >
                            {role
                              .replace(/_/g, " ")
                              .replace(/\b\w/g, (l) => l.toUpperCase())}
                          </Tag>
                        ))
                      ) : (
                        <Tag>No roles assigned</Tag>
                      )}
                    </div>
                  </div>
                  <Popconfirm
                    title="Delete Roles?"
                    description="Are you sure you want to remove all roles for this assignment?"
                    onConfirm={() => {
                      const payload = {
                        userId: selectedUserForInfo._id,
                        flatId: assignment?.flat_id,
                        wingId: assignment?.wing_id,
                        roles: assignment?.roles,
                      };
                      handleDeleteRole(payload);
                      setInfoModalVisible(false);
                    }}
                    okText="Yes"
                    cancelText="No"
                  >
                    <Button icon={<DeleteOutlined />} danger type="primary" />
                  </Popconfirm>
                </div>
              ))
            ) : (
              <Empty description="No assignments found for this user." />
            )}
          </div>
        ) : (
          <Empty description="No user selected." />
        )}
      </Modal>
    </>
  );
};

export default ManageUsersComponent;
